import includes from "lodash/includes";
import isString from "lodash/isString";
import styled from "styled-components";
export default {
    PathContainer: styled.div
        .withConfig({
        shouldForwardProp: (prop) => !includes(["height"], prop)
    })
        .attrs({
        className: "nowrap text-overflow-ellipsis"
    }) `
    display: flex;
    vertical-align: middle;
    align-items: center;
    ${({ height }) => height && `height: ${isString(height) ? height : `${height}px`};`}
    > * {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    > span:last-child {
      font-weight: bold;
    }
  `
};
